var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhite3Inline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 108,
  height: 77,
  viewBox: "0 0 108 77",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M107.9 40.6c0-4.5-2.9-8.2-7.3-8.2-2.2 0-4.9 2.4-6.3 3.9-1.4-1.5-3.9-3.9-6.1-3.9-4.4 0-7.5 3.7-7.5 8.2 0 2.3.9 4.3 2.3 5.8l11.3 11.3 11.3-11.3c1.4-1.5 2.3-3.5 2.3-5.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9 76.1c-1-.1-1.7-.7-1.8-1.5l-5.7-33.4-8.7 16.1c-.4.7-1.2 1.1-2 .9-.8-.1-1.4-.8-1.5-1.6l-3.7-25.8-6.7 15.1c-.3.7-1 1.1-1.7 1.1H1.9c-1 0-1.9-.8-1.9-1.9 0-1 .8-1.9 1.9-1.9h25l8.9-19.9c.3-.8 1.1-1.2 1.9-1.1.8.1 1.5.8 1.6 1.6l3.8 26.6 8.6-15.9c.4-.7 1.1-1.1 1.9-.9.8.1 1.4.7 1.5 1.5L60.4 66 79.7 1.8c.2-.7.9-1.3 1.6-1.3.8-.1 1.5.4 1.8 1l10.2 21.1c.4.9.1 2-.9 2.5-.9.4-2 .1-2.5-.9L81.8 7.4 61.6 74.6c-.2 1-.9 1.5-1.7 1.5Z"
}))));
export default SvgWhite3Inline;